<template>
<div>
    <div class="login_wrap">
        <dl>
            <dt>휴대폰 인증</dt>
            <dd>
                <!-- 반갑습니다! {{authWrite.name}}님.<br> -->
                반갑습니다!<br>
                신원 확인을 위해 휴대폰 인증을 진행합니다.
            </dd>
        </dl>
    </div>

    <div class="btn_box_fixed">
        <a class="default_btn1" @click="niceAuth();">본인인증</a>
    </div>
</div>

</template>

<script>
import {NiceMixin} from '../../mixins/NiceMixin';
export default {
    name:'JoinNiceAuth',
    mixins:[
        NiceMixin
    ],
    created() {
        this.$store.commit('SHOW_ONLOAD');
    },

    data() {
        return {
            authWrite: this.$store.state.auth.itemWrite,
        }
    },
    
    computed: {},

    methods: {
        //본인 인증
        niceAuth() {
            this.callbackPopup('Nice', this.niceResult)
        },

        //본인 인증 성공
        niceResult() {
            let niceData = this.niceGetResult();
            //성공시에만 niceData 존재
            if(niceData) {
                this.$store.dispatch('CREATE_USER_CHECK', niceData.phone)
                .then(()=>{
                    this.authWrite.name = niceData.name;
                    this.authWrite.phone = niceData.phone;
                    this.authWrite.gender = niceData.gender;
                    this.$router.push('/join/password');
                })
                .catch((e)=>{
                    this.apiCatch(e);
                })
            }
        }
    },
}
</script>

<style lang="scss" scoped>

</style>